import { numberComparatorForFormattedValues, systemStatusComparator } from "utils/comparatorUtils";
import { systemStatusText } from "utils/utils";
import { StatusText, SYSTEM_TABLE_COLUMNS, SYSTEMS_TABLE_STRINGS, valueStrings } from "constants/constantStrings";
import SYSTEM_STATUS from "constants/systemStatus";

const connectionStatusText = params => {
  let systemStatus = StatusText.disconnected;
  if (params) {
    if (params.data.connectionStatus.toString() === SYSTEM_STATUS.STATUS_ONLINE) {
      systemStatus = StatusText.online;
    } else if (params.data.connectionStatus.toString() === SYSTEM_STATUS.STATUS_OFFLINE) {
      systemStatus = StatusText.offline;
    } else systemStatus = StatusText.disconnected;
  }
  return systemStatus;
};

const customValueFormatter = params => {
  const data = params?.data;
  const colId = params?.column.colId;
  let value = data?.[colId]?.value;
  if (data?.connectionStatus !== SYSTEM_STATUS.STATUS_ONLINE || value === null) {
    value = valueStrings.dash;
  }
  return value;
};

export const getSystemsTableConfig = showTableFilterIcon => [
  {
    field: "sysId",
    headerName: SYSTEM_TABLE_COLUMNS.sysId,
    flex: 1.5,
    editable: false,
    filter: showTableFilterIcon,
    newRowsAction: "keep"
  },
  {
    field: "systemName",
    headerName: SYSTEM_TABLE_COLUMNS.systemName,
    flex: 1.5,
    editable: false,
    filter: showTableFilterIcon,
    newRowsAction: "keep"
  },
  {
    field: "recovery",
    headerName: SYSTEMS_TABLE_STRINGS.recovery,
    flex: 1,
    editable: false,
    filter: showTableFilterIcon,
    valueFormatter: customValueFormatter,
    comparator: numberComparatorForFormattedValues,
    newRowsAction: "keep"
  },
  {
    field: "production",
    headerName: SYSTEMS_TABLE_STRINGS.production,
    flex: 1,
    editable: false,
    filter: showTableFilterIcon,
    valueFormatter: customValueFormatter,
    comparator: numberComparatorForFormattedValues,
    newRowsAction: "keep"
  },
  {
    field: "conductivity",
    headerName: SYSTEMS_TABLE_STRINGS.conductivity,
    editable: false,
    flex: 1,
    filter: showTableFilterIcon,
    valueFormatter: customValueFormatter,
    comparator: numberComparatorForFormattedValues,
    newRowsAction: "keep"
  },
  {
    field: "connectionStatus",
    headerName: SYSTEMS_TABLE_STRINGS.connectionStatus,
    valueFormatter: connectionStatusText,
    editable: false,
    flex: 1.2,
    filter: showTableFilterIcon,
    newRowsAction: "keep"
  },
  {
    field: "systemStatus",
    headerName: SYSTEMS_TABLE_STRINGS.systemStatus,
    valueFormatter: systemStatusText,
    editable: false,
    flex: 1,
    filter: showTableFilterIcon,
    comparator: systemStatusComparator,
    newRowsAction: "keep"
  }
];
